import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChatCircleDots, Phone, User } from '@phosphor-icons/react';
import CustomerChat from './CustomerChat';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const normalizeIndianPhone = (value) => {
  let phone = String(value || '').replace(/[\s-]/g, '');
  if (phone.startsWith('+91')) phone = phone.slice(3);
  else if (phone.startsWith('0')) phone = phone.slice(1);
  return phone;
};

export default function SupportChat() {
  const [session, setSession] = useState(null);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('inquiry_session') || 'null');
      if (saved?.is_support_chat && saved.token && saved.chat_room_id) setSession(saved);
    } catch (_) {}
  }, []);

  if (session) return <CustomerChat chatType="inquiry" />;

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    const normalized = normalizeIndianPhone(phone);
    if (!/^[6-9]\d{9}$/.test(normalized)) {
      setError('Enter a valid 10-digit Indian mobile number.');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${API}/guest-inquiries`, { name: name.trim() || null, phone });
      const next = { ...response.data, is_support_chat: true, is_inquiry: true, is_guest: true };
      localStorage.setItem('inquiry_session', JSON.stringify(next));
      setSession(next);
    } catch (err) {
      setError(err.response?.data?.error || 'Unable to start chat. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-wa-hover flex items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-md bg-wa-panel rounded-2xl shadow-xl p-7 space-y-5">
        <div className="text-center">
          <ChatCircleDots size={48} weight="duotone" className="mx-auto text-[#00a884]" />
          <h1 className="text-2xl font-bold mt-3 text-wa-text-primary">Chat Support</h1>
          <p className="text-sm text-wa-text-secondary mt-1">Start a conversation with our support team.</p>
        </div>
        <label className="block text-sm font-semibold text-wa-text-primary">Name (optional)
          <span className="mt-1 flex items-center gap-2 border rounded-xl px-3 py-2"><User size={19} /><input value={name} onChange={e => setName(e.target.value)} maxLength={60} className="w-full outline-none bg-transparent" /></span>
        </label>
        <label className="block text-sm font-semibold text-wa-text-primary">Phone number <span className="text-red-500">*</span>
          <span className="mt-1 flex items-center gap-2 border rounded-xl px-3 py-2"><Phone size={19} /><input value={phone} onChange={e => setPhone(e.target.value)} inputMode="tel" autoComplete="tel" placeholder="+91 9876543210" className="w-full outline-none bg-transparent" required /></span>
        </label>
        {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
        <button type="submit" disabled={loading} className="w-full rounded-xl bg-[#00a884] text-white font-bold py-3 disabled:opacity-60">{loading ? 'Starting chat…' : 'Start chat'}</button>
      </form>
    </main>
  );
}
